define('formkit/view/form.object/answer.form.object.view',['require','exports','module','../../templates','./base.form.object.view','./common/answer.form.object.top.view'],function(require, exports, module) {
  //prettier-ignore
  var Templates               = require('../../templates'),
      BaseFormObjectView      = require('./base.form.object.view'),
      AnswerFormObjectTopView = require('./common/answer.form.object.top.view');

  var AnswerFormObjectView = BaseFormObjectView.extend({
    className: 'ui answer formObject',

    options: {
      readonly: false,
    },

    internalViewOptions: BaseFormObjectView.extendInternalViewOptions({
      topView: function() {
        return {
          type: AnswerFormObjectTopView,
        };
      },
      contentView: function() {
        return {};
      },
    }),

    initialize: function() {
      BaseFormObjectView.prototype.initialize.call(this, arguments);

      // If we have a model with an answerModel, get its readonly status, otherwise default to not readonly
      this.readonly = this.model && this.model.get('answer') ? this.model.get('answer').get('readOnly') : false;
    },

    updateAttributes: function() {
      this.addClass('read-only', this.readonly);
    },
  });

  module.exports = AnswerFormObjectView;
});

